import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { FaMoon, FaRegMoon } from 'react-icons/fa';
import { MdOutlineLightMode } from 'react-icons/md';

const ThemeToggle = ({ className = '', size = 'md' }) => {
  const { isDark, toggleTheme } = useTheme();

  const sizeStyles = {
    sm: { width: '2.5rem', height: '1.25rem', circle: '1rem', icon: '0.55rem' },
    md: { width: '3rem', height: '1.5rem', circle: '1.25rem', icon: '0.75rem' },
    lg: { width: '3.5rem', height: '1.8rem', circle: '1.5rem', icon: '1rem' },
    xl: { width: '4.1rem', height: '2.1rem', circle: '1.75rem', icon: '1.1rem' }
  };

  const currentSize = sizeStyles[size] || sizeStyles.md;

  return (
    <button
      onClick={toggleTheme}
      className={className}
      style={{
        marginTop: 0,
        width: currentSize.width,
        height: currentSize.height,
        borderRadius: '9999px',
        backgroundColor: !isDark ? '#202727' : '#FFFFFF',
        border: '1px solid var(--border-secondary)',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
      }}
      aria-label={`Alternar para modo ${isDark ? 'claro' : 'escuro'}`}
      title={`Alternar para modo ${isDark ? 'claro' : 'escuro'}`}
    >
      {/* Ícone do Sol (lado esquerdo) */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '8px',
          transform: 'translateY(-50%)',
          fontSize: currentSize.icon,
          color: isDark ? '#6B7280' : '#000000',
          transition: 'all 0.3s ease'
        }}
      >
        <MdOutlineLightMode />
      </span>

      {/* Ícone da Lua (lado direito) */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          right: '8px',
          transform: 'translateY(-50%)',
          fontSize: currentSize.icon,
          color: isDark ? '#000000' : '#fff',
          transition: 'all 0.3s ease'
        }}
      >
        <FaRegMoon />
      </span>

      {/* Bola que se move */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: isDark
            ? `calc(100% - ${currentSize.circle} - 2px)`
            : '2px',
          transform: 'translateY(-50%)',
          width: currentSize.circle,
          height: currentSize.circle,
          borderRadius: '50%',
          backgroundColor: !isDark ? '#FFFFFF' : '#000000',
          transition: 'all 0.3s ease'
        }}
      ></span>
    </button>
  );
};

export default ThemeToggle;
